import type { CompanyArticleSubject, GalleryItemType } from "@/modules/companies/api/types"

export const EVENTS_PAGE_SIZE = 1000
export const ARTICLES_PAGE_SIZE = 9

type BusinessType = Record<string, string>
export const BUSINESS_TYPES: BusinessType = {
  COMPANY_PAGE_BUSINESS_TYPE_LARGE: "COMPANY_PAGE_BUSINESS_TYPE_LARGE",
  COMPANY_PAGE_BUSINESS_TYPE_NGO_PUBLIC_LAB: "COMPANY_PAGE_BUSINESS_TYPE_NGO_PUBLIC_LAB",
  COMPANY_PAGE_BUSINESS_TYPE_SME: "COMPANY_PAGE_BUSINESS_TYPE_SME",
  COMPANY_PAGE_BUSINESS_TYPE_START_UP: "COMPANY_PAGE_BUSINESS_TYPE_START_UP",
  COMPANY_PAGE_BUSINESS_TYPE_UNSPECIFIED: "COMPANY_PAGE_BUSINESS_TYPE_UNSPECIFIED",
}

type BusinessTypeI18n = Record<string, string>
export const BUSINESS_TYPES_I18N: BusinessTypeI18n = {
  COMPANY_PAGE_BUSINESS_TYPE_COLLECTIVE: "collective",
  COMPANY_PAGE_BUSINESS_TYPE_LARGE: "large",
  COMPANY_PAGE_BUSINESS_TYPE_NGO_PUBLIC_LAB: "ngo_public_lab",
  COMPANY_PAGE_BUSINESS_TYPE_OTHER: "other",
  COMPANY_PAGE_BUSINESS_TYPE_SME: "sme",
  COMPANY_PAGE_BUSINESS_TYPE_START_UP: "start_up",
}

type ArticleSubjectI18n = Record<CompanyArticleSubject, string>

export type ArticleType = "challenge" | "company_life" | "meeting" | "other" | "recruitment"
export const ARTICLE_SUBJECT_TYPES_I18N: ArticleSubjectI18n = {
  ARTICLE_SUBJECT_CHALLENGE: "challenge",
  ARTICLE_SUBJECT_CORPORATE_SOCIAL_RESPONSIBILITY: "company_life",
  ARTICLE_SUBJECT_MEETING: "meeting",
  ARTICLE_SUBJECT_OTHER: "other",
  ARTICLE_SUBJECT_RECRUITMENT: "recruitment",
  ARTICLE_SUBJECT_UNSPECIFIED: "other",
}

type ArticleSubjectAPI = Record<string, CompanyArticleSubject>
export const ARTICLE_SUBJECT_TYPES_API: ArticleSubjectAPI = {
  challenge: "ARTICLE_SUBJECT_CHALLENGE",
  company_life: "ARTICLE_SUBJECT_CORPORATE_SOCIAL_RESPONSIBILITY",
  meeting: "ARTICLE_SUBJECT_MEETING",
  other: "ARTICLE_SUBJECT_OTHER",
  recruitment: "ARTICLE_SUBJECT_RECRUITMENT",
}

export const MEDIA_TYPE_IMAGE: GalleryItemType = "MEDIA_TYPE_IMAGE"
export const MEDIA_TYPE_VIDEO: GalleryItemType = "MEDIA_TYPE_VIDEO"
